import { View } from '@react-pdf/renderer'
import { Objectclass, YesObject } from '@yes.technology/react-toolkit'
import {
  DEFAULT_TABLE_LAYOUT,
  TableLayout
} from 'site/Renderer/components/DataTables/hooks/useTableLayouts'
import PDFDataTable from 'report/components/PDFDataTable/PDFDataTable'
import { ConcatFields } from 'shared/utils/object/concatenateFields'
import useColumns from 'site/Renderer/components/DataTables/hooks/useColumns'

type RelationDataTableProps = {
  columns: string[]
  fields: Objectclass['fields']
  objects: YesObject[]
  relationName: string
  tableLayout?: TableLayout
  concatFields?: ConcatFields
}

function RelationDataTable({
  columns,
  fields,
  objects,
  relationName,
  tableLayout = DEFAULT_TABLE_LAYOUT,
  concatFields
}: RelationDataTableProps) {
  const { allColumns: displayedColumns } = useColumns({
    tableLayout
  })

  return (
    <View>
      <PDFDataTable
        objects={objects}
        fields={fields}
        columns={displayedColumns}
        itemsPerPage={10}
        title={relationName}
        concatFields={concatFields}
      />
    </View>
  )
}

export default RelationDataTable
